module.exports = __webpack_public_path__ + "static/media/stilly4.129be30e.JPG";